import { styled, TableContainer, Chip, alpha } from '@mui/material';

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    '& .MuiTableHead-root': {
        '& .MuiTableCell-root': {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.secondary,
            fontSize: '0.875rem',
            fontWeight: 500,
            borderBottom: `1px solid ${theme.palette.divider}`,
            padding: '12px 16px',
        }
    },
    '& .MuiTableBody-root': {
        '& .MuiTableRow-root': {
            '&:hover': {
                backgroundColor: 'rgba(67, 129, 247, 0.04)',
            },
            '&.selected': {
                backgroundColor: 'rgba(67, 129, 247, 0.08)',
            }
        },
        '& .MuiTableCell-root': {
            padding: '16px',
            fontSize: '0.875rem',
            color: theme.palette.text.primary,
        }
    }
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
    borderRadius: '16px',
    fontSize: '0.75rem',
    height: '24px',
}));

export const StatusChip = styled(StyledChip)<{ status: string }>(({ theme, status }) => {
    const getStatusStyles = () => {
        switch (status.toLowerCase()) {
            case 'new':
                return {
                    backgroundColor: 'rgba(25, 118, 210, 0.08)',
                    color: theme.palette.primary.main,
                };
            case 'approved':
                return {
                    backgroundColor: 'rgba(46, 125, 50, 0.08)',
                    color: theme.palette.success.main,
                };
            case 'rejected':
                return {
                    backgroundColor: 'rgba(211, 47, 47, 0.08)',
                    color: theme.palette.error.main,
                };
            case 'in progress':
                return {
                    backgroundColor: 'rgba(237, 108, 2, 0.08)',
                    color: theme.palette.warning.main,
                };
            default:
                return {
                    backgroundColor: theme.palette.grey[100],
                    color: theme.palette.text.secondary,
                };
        }
    };
    return {
        ...getStatusStyles(),
    };
});

export const ScoreChip = styled(StyledChip)<{ score: number }>(({ theme, score }) => ({
    backgroundColor: score >= 60 ? 'rgba(46, 125, 50, 0.08)' : 'rgba(211, 47, 47, 0.08)',
    color: score >= 60 ? theme.palette.success.main : theme.palette.error.main,
})); 